export default {
  eyebrow: 'Portal partener',
  title: 'Cont',
  description: 'Detaliile contului dvs. de partener.',
  page: {
    read_only_notice: 'Doar citire. Faceți clic pe Editare pentru a modifica orice valoare.',
    editing_notice: 'Editare — modificările sunt vizibile pentru echipa și clienții dvs.',
  },
  profile: {
    form: {
      name: {
        label: 'Nume partener',
        hint: 'Denumirea legală / entitatea. Folosită pe documentele de facturare.',
      },
      display_name: {
        label: 'Nume afișat pentru consumatori',
        hint: 'Eticheta „Powered by ___" pe care clienții dvs. o văd în restaurantele dvs. Implicit este numele partenerului dacă este lăsat necompletat.',
      },
      support_email: {
        label: 'Email de contact',
        hint: 'Unde vă pot contacta FoodAmigos și clienții dvs. Emailul de autentificare rămâne neschimbat.',
      },
      invoicing_emails: {
        label: 'E-mailuri pentru facturi',
        hint: 'Chitanțele pentru facturile emise pe numele dvs. sunt trimise la fiecare dintre aceste adrese. Lăsați gol pentru a folosi e-mailul de autentificare.',
        placeholder: 'E-mailul dvs. de autentificare',
      },
    },
  },
  buttons: {
    edit: 'Editare',
    cancel: 'Anulare',
    save: 'Salvare',
  },
  toasts: {
    load_error: 'Nu s-au putut încărca detaliile contului dvs.',
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
